import { useMemo } from 'react';
import FilterTypes from '@constants/FilterTypes';
import { translate } from '@utils/i18n';
import { kitOrderActionTypes } from './kitOrdersReducer';
import { KIT_ORDERS_NAMESPACE } from '../constants';
const useKitOrderFilters = ({ filters, dispatch }) => {
    const onChangeFilter = (fieldName) => (value) => {
        dispatch({ type: kitOrderActionTypes.FILTER_CHANGED, field: fieldName, value });
    };
    const onToggleFilter = (fieldName) => () => {
        dispatch({ type: kitOrderActionTypes.FILTER_TOGGLED, field: fieldName });
    };
    const onChangeDateFilter = (fieldName) => (dateFieldName, value) => {
        dispatch({
            type: kitOrderActionTypes.DATE_RANGE_FILTER_CHANGED,
            field: fieldName,
            dateField: dateFieldName,
            value
        });
    };
    const onSearchChange = (value) => {
        dispatch({ type: kitOrderActionTypes.SEARCH_CHANGED, search: value });
    };
    const filtersList = useMemo(() => [
        {
            field: 'orderDate',
            locale: 'order_date',
            type: FilterTypes.DateRangePicker,
            active: filters.active.orderDate,
            values: filters.values.orderDate,
            onChange: onChangeDateFilter('orderDate'),
            onToggle: onToggleFilter('orderDate')
        },
        {
            field: 'user',
            backendField: 'kit_order_user',
            locale: 'order_sent_by',
            type: FilterTypes.GenericMultiSelect,
            active: filters.active.user,
            value: filters.values.user,
            onChange: onChangeFilter('user'),
            onToggle: onToggleFilter('user')
        },
        {
            field: 'status',
            locale: 'status',
            type: 'commonSelect',
            active: filters.active.status,
            value: filters.values.status,
            onChange: onChangeFilter('status'),
            onToggle: onToggleFilter('status'),
            optionsForSelect: [
                { value: 'pending', label: translate('kit_orders.status.sent', { namespace: KIT_ORDERS_NAMESPACE }) },
                { value: 'completed', label: translate('kit_orders.status.received', { namespace: KIT_ORDERS_NAMESPACE }) }
            ]
        }
    ], [filters, dispatch]);
    return { filtersList, onSearchChange };
};
export default useKitOrderFilters;
